import { StringMapping, ValueMapping } from "@opendaw/lib-std";
import { AbstractModuleAdapter } from "../abstract";
import { Direction, ModuleConnectorAdapter } from "../connector";
export class ModuleDelayAdapter extends AbstractModuleAdapter {
    #parameterTime;
    #voltageInput;
    #voltageOutput;
    constructor(context, box) {
        super(context, box);
        this.#parameterTime = this.parameters.createParameter(box.time, ValueMapping.exponential(1.0, 10000.0), StringMapping.numeric({ unit: "ms" }), "Time");
        this.#voltageInput = ModuleConnectorAdapter.create(context.boxAdapters, box.voltageInput, Direction.Input, "Input");
        this.#voltageOutput = ModuleConnectorAdapter.create(context.boxAdapters, box.voltageOutput, Direction.Output, "Output");
    }
    get parameterTime() { return this.#parameterTime; }
    get voltageInput() { return this.#voltageInput; }
    get voltageOutput() { return this.#voltageOutput; }
    get inputs() {
        return [this.#voltageInput];
    }
    get outputs() {
        return [this.#voltageOutput];
    }
}
